<template>
	<div class="panel">
		<div class="heading-5">{{ label }}</div>
		<slot></slot>
	</div>
</template>
<script>
export default {
	props: {
		label: {
			type: String,
			default: ''
		}
	}
};
</script>
<style lang="scss" scoped>
.panel {
	width: 270px;

	@media (min-width: $breakpoint-mid) {
		width: 360px;
	}

	@media (min-width: $breakpoint-max) {
		width: 420px;
	}

	&:not(:last-child) {
		margin-bottom: 24px;
		padding-bottom: 24px;
		border-bottom: 1px solid $container-border;
	}

	.heading-5 {
		color: $font-dark;
		margin-bottom: 16px;
		text-align: center;
	}
}
</style>
